/**
 * The languages the app's interface ships in: the web's locale files, and the
 * language a user's emails are written in. One list, so the API accepts only
 * a language the web and the worker can render.
 * Europe first, then the Indian languages, then the right-to-left pair.
 */
export const UI_LANGUAGES = [
  'en', 'nl', 'de', 'fr', 'es', 'it', 'pt',
  'bg', 'cs', 'da', 'el', 'et', 'fi', 'ga',
  'hr', 'hu', 'is', 'lt', 'lv', 'mt', 'nb',
  'pl', 'ro', 'sk', 'sl', 'sv',
  'ml', 'hi', 'ta', 'te', 'kn', 'bn',
  'ar', 'ur',
] as const;

export type UiLanguage = (typeof UI_LANGUAGES)[number];

export const RTL_UI_LANGUAGES: readonly UiLanguage[] = ['ar', 'ur'];

/** `de-AT` → `de` when that is a UI language; null otherwise. */
export function toUiLanguage(value: unknown): UiLanguage | null {
  if (typeof value !== 'string') return null;
  const base = value.trim().toLowerCase().split(/[-_]/)[0] ?? '';
  return (UI_LANGUAGES as readonly string[]).includes(base) ? (base as UiLanguage) : null;
}

/** The Supabase `user_metadata` key holding the user's interface language. */
export const UI_LANGUAGE_METADATA_KEY = 'ui_language';
